import React, {useEffect, useState} from "react"
import {useForm} from "react-hook-form";
import {useLocation, useNavigate} from "react-router";
import OtpVerification from "./otp-verification/OtpVerification";
import Heading from "../../../components/dashboard/heading-component/Heading";

export default function ForgotPassword( ) {
    const { state } = useLocation();

    const [openOtp, setOpenOtp] = useState();
    // const { redirect} = location.state;

    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors},
        control,
        clearErrors
    } = useForm({
        mode: 'onChange',
    })
    const navigate = useNavigate()
    const onSubmit = async (data) => {
        setOpenOtp(true)

    }

    useEffect(()=>{
        if (state === null) {
            navigate('/forgot-password');
        }
    })



    return(
        <div className={'login'}>
            <Heading back={true} heading={'OTP Verification'}/>
            <h5>Please enter the OTP you received to <br/>
                <span className={'text-white'}>{state?.email}</span>
            </h5>
            <OtpVerification redirect={'/change-password'} email={state?.email}/>
        </div>
    )
}